import React from 'react'
import PropTypes from 'prop-types'

const Confirmation = props => {
  return (
    <div>
      <h3 className="text-dark-blue">Thank you for your order!</h3>
      <p>A confirmation has been sent to: {props.email}</p>
    </div>
  )
}

Confirmation.propTypes = {
  email: PropTypes.string,
}

export default Confirmation
